import women from '../src/Images/women.webp'; 
import women4 from '../src/Images/women4.webp'; 
import women6 from '../src/Images/women6.webp'; 
import man3 from '../src/Images/man3.webp'; 


export const dataPortfolio = [
  
  {
    id: '15p',
    title: 'Math Game For Kiddos',
    detail: 'Built with: HTML & CSS, TailwindCSS, JavaScript, and DynamicHTML ',
    myLink: 'https://java-script-math-game-kids.vercel.app/',
    image:
      'https://plus.unsplash.com/premium_photo-1719329701984-b2f879ebaa5d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bWF0aCUyMGdhbWV8ZW58MHx8MHx8fDA%3D',
    alt: 'Kids',
    
  },
  {
    id: '14p',
    title: 'Gym Memberships - Still in progress.',
    detail: 'Built with: HTML & CSS, TailwindCSS, JavaScript, and DynamicHTML ',
    myLink: 'https://java-script-gym-member-booking.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1578882113036-761708189373?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGV4Y2VyY2lzZXxlbnwwfHwwfHx8MA%3D%3D',
    alt: 'Kids',
  },

  {
    id: '11p',
    title: 'Custom Website Design',
    detail: 'Built with: JavaScript, DynamicHTML, HTML & CSS',
    myLink: 'https://java-script-customize-web-page-o9ct.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1589652717521-10c0d092dea9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dXNlJTIwY29tcHV0ZXJ8ZW58MHx8MHx8fDA%3D',
    alt: 'a small brown dog uses computer',
  },
  {
    id: '1p',
    title: 'E-commerce Farm Websites',
    detail: 'Built with: HTML & CSS, jQuery, Bootstrap, SEO, TailwindCSS',
    myLink: 'https://bootstrap-farm-project.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1536657464919-892534f60d6e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8b3JhbmdlJTIwZmFybXxlbnwwfHwwfHx8MA%3D%3D',
    alt: 'Orange Farm',
  },
  {
    id: '2p',
    title: 'Body Mass Index (BMI) Calculation',
    detail: 'Built with: JavaScript, DynamicHTML, and CSS',
    myLink: 'https://bmi-calculatation.vercel.app/',
    image:
      'https://images.pexels.com/photos/278887/pexels-photo-278887.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'guessWord',
  },
  {
    id: '3p',
    title: 'Tic Tac Toe',
    detail: 'Built with: JavaScript, DynamicHTML, and CSS',
    myLink: 'https://tic-tac-605mcgzbr-sukanyat2022.vercel.app/',
    image:
      'https://images.pexels.com/photos/3400795/pexels-photo-3400795.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'tictactoe',
  },
  {
    id: '4p',
    title: 'Thai Food Ingredients Store Website',
    detail: 'Built with: JavaScript, HTML & CSS and Bootstrap',
    myLink: 'https://elegant-marzipan-795171.netlify.app',
    image:
      'https://images.pexels.com/photos/4541339/pexels-photo-4541339.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'chili',
  },
  {
    id: '5p',
    title: 'Commercial Website Marshall Speaker',
    detail: 'Built with: HTML & CSS, Bootstrap, and JavaScript',
    myLink: 'https://cheery-sprinkles-fdc5fa.netlify.app',
    image:
      'https://plus.unsplash.com/premium_photo-1676722631511-c003f7d87b91?q=80&w=2500&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'speaker',
  },
  {
    id: '6p',
    title: 'Travel Website',
    detail: 'Built with:JavaScript, HTML & CSS and Bootstrap',
    myLink: 'https://exquisite-piroshki-2e9c8e.netlify.app',
    image:
      'https://plus.unsplash.com/premium_photo-1666497934040-ec832d302f13?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG1hbGRpdmV8ZW58MHx8MHx8fDA%3D',
    alt: 'beach',
  },
  {
    id: '8p',
    title: 'National Park Website',
    detail: 'Built with: HTML & CSS, Bootstrap, and JavaScript',
    myLink: 'https://ornate-cactus-5ee33c.netlify.app',
    image:
      'https://images.unsplash.com/photo-1651262450997-c27f6468f5ba?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bmF0aW9uYWwlMjBwYXJrJTIweW9zZW1pdGl8ZW58MHx8MHx8fDA%3D',
    alt: 'nationalPark',
  },
  {
    id: '9p',
    title: 'Tuxedo Shop Website',
    detail: 'Built with: HTML & CSS, Bootstrap, and JavaScript',
    myLink: 'https://meek-chimera-59f2b1.netlify.app',
    image:
      'https://images.pexels.com/photos/177328/pexels-photo-177328.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'tuxedo',
  },
  {
    id: '10p',
    title: 'Password Generator',
    detail:
      'Built with: JavaScript (Math.random and Math.floor method), HTML & CSS',
    myLink: 'https://java-script-password-generator.vercel.app/',
    image:
      'https://cdn.pixabay.com/photo/2017/01/01/14/39/hacker-1944688_1280.jpg',
    alt: 'password',
  },
];

export const dataReact = [
    {
    id: '16p',
    title: 'Apartment Rental Website - Still in progress.',
    detail: 'Built with: Next.js, TailwindCSS, Node.js | Express.js, MongoDB, and REST API integration',
    myLink: 'https://github.com/SukanyaT2022/NextJS-AptRentalApp-Frontend.git',
    image:
      'https://media.istockphoto.com/id/1145034668/photo/modern-european-complex-of-apartment-buildings.webp?a=1&b=1&s=612x612&w=0&k=20&c=ENxHTmJc0BExeFSlajbjRQk3dU9J0KMxbDdROIpL8Ak=',
    alt: 'apartment rental',
  },
  {
    id: '15p',
    title: 'Anti-Bully Blog',
    detail: 'Built with: React, JavaScript, HTML, CSS,and TailwindCSS',
    myLink: 'https://react-js-anti-bully-blog.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1572670014853-1d3a3f22b40f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c3RvcHxlbnwwfHwwfHx8MA%3D%3D',
    alt: 'Stop Sign',
  },
  {
    id: '1p',
    title: 'Kids Designer Clothes',
    detail: 'Built with: React, JavaScript, JSON, HTML, CSS, and React-Bootstrap',
    myLink: 'https://react-js-children-fashion.vercel.app/',
    image:
      'https://images.pexels.com/photos/1620758/pexels-photo-1620758.jpeg?auto=compress&cs=tinysrgb&w=600',
    alt: 'children fashion',
  },
  {
    id: '2p',
    title: 'Wine Shop',
    detail: 'Built with: React, JavaScript, JSON, HTML, CSS, and React-Bootstrap',
    myLink: 'https://react-wine-shop-interface.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1524250426644-e24b385c291a?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8d2luZSUyMHNob3B8ZW58MHx8MHx8fDA%3D',
    alt: 'guessWord',
  },
  {
    id: '3p',
    title: 'Photo Search',
    detail: 'Built with: React, JavaScript, JSON, HTML, CSS, React-Bootstrap, and REST API integration ',
    myLink: 'https://react-rest-ap-is-pixel-cone.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1515598379512-b60132823a9d?w=1400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c2VhcmNoaW5nfGVufDB8fDB8fHww',
    alt: 'women searchs',
  },
  {
    id: '4p',
    title: 'Take Quiz',
    detail: 'Built with: React, JavaScript, HTML, CSS, Responsive web design',
    myLink: 'https://react-js-take-quizzs.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1662120455989-5a433cec9980?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cXVpenp8ZW58MHx8MHx8fDA%3D',
    alt: 'quizz',
  },
  {
    id: '5p',
    title: 'Halloween Emoji Search',
    detail: 'Built with: HTML & CSS, Bootstrap, and JavaScript',
    myLink: 'https://react-js-emoji-search.vercel.app',
    image:
      'https://plus.unsplash.com/premium_photo-1684979565684-e350fc89a29d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGVtb2ppfGVufDB8fDB8fHww',
    alt: 'Emoji',
  },
  {
    id: '6p',
    title: 'Expense Tracker',
    detail: 'Built with: React, JavaScript, JSON, HTML, CSS, and React-Bootstrap ',
    myLink: 'https://track-expense-98p1ihbpi-sukanyat2022.vercel.app',
    image:
      'https://plus.unsplash.com/premium_photo-1679397743664-f9384e6ad49d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bW9uZXl8ZW58MHx8MHx8fDA%3D',
    alt: 'Money',
  },
 
  {
    id: '9p',
    title: 'Fruite Slider',
    detail: 'Built with: React, JavaScript, HTML, CSS',
    myLink: 'https://react-js-slider-two.vercel.app',
    image:
      'https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGZydWl0ZXN8ZW58MHx8MHx8fDA%3D',
    alt: 'fruite',
  },
  {
    id: '10p',
    title: 'Weather App',
    detail:
      'Built with: React, JavaScript, HTML, CSS, and REST API integration',
    myLink: 'https://react-js-weather-app-eosin.vercel.app',
    image:
      'https://images.unsplash.com/photo-1516912481808-3406841bd33c?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8d2VhdGhlcnxlbnwwfHwwfHx8MA%3D%3D',
    alt: 'weather',
  },
  {
    id: '11p',
    title: 'Cypto Price Tracker',
    detail:
      'Built with: React, JavaScript, HTML, CSS, React-Bootstrap, and Rest APIs ',
    myLink: 'https://react-js-coin-track-rlnzznt9d-sukanyat2022.vercel.app',
    image:
      'https://images.unsplash.com/photo-1621932936282-c6da87b809f3?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y3lwdG98ZW58MHx8MHx8fDA%3D',
    alt: 'password',
  },
  {
    id: '12p',
    title: 'Shopping Cart',
    detail:
      'Built with: React, JavaScript, HTML, and CSS',
    myLink: 'https://stalwart-longma-b29c72.netlify.app',
    image:
      'https://plus.unsplash.com/premium_photo-1683798464819-d1376249293e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fHNob3BpbmclMjBjYXJ0fGVufDB8fDB8fHww',
    alt: 'Shopping Cart',
  },
  {
    id: '13p',
    title: 'Snap Shot',
    detail:
      'Built with:&nbsp;React, JavaScript, HTML, and CSS',
    myLink: 'https://stellar-babka-c67ce5.netlify.app',
    image:
      'https://images.unsplash.com/photo-1516918842892-1c43ea4ad867?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c25hcHNob3R8ZW58MHx8MHx8fDA%3D',
    alt: 'camera',
  },
  {
    id: '14p',
    title: 'To Do Lists',
    detail:
      'Built with: React, JavaScript, HTML, and CSS',
    myLink: 'https://jolly-cuchufli-4c2034.netlify.app',
    image:
      'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dG9kb2xpc3R8ZW58MHx8MHx8fDA%3D',
    alt: 'todolist',
  },

];
export const dataSwift = [
  {
    id: '6p',
    title: 'Jungle Hotel App',
    detail: 'Built with: SwiftUI',
    myLink: 'https://github.com/SukanyaT2022/JungleHotel.git',
    deployLink: 'https://github.com/SukanyaT2022/JungleHotel.git',
    image:
      'https://images.unsplash.com/photo-1572818927875-9aa8d8fc22c0?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGp1bmdsZSUyMGhvdGVsfGVufDB8MHwwfHx8MA%3D%3D',
    alt: 'jungle hotel',
    appleStoreLink: "https://apps.apple.com/in/app/jungle-booking/id6757864801",
  },
  {
    id: '7p',
    title: 'Pet Social App',
    detail: 'Built with: SwiftUI',
    myLink: 'https://github.com/SukanyaT2022/SwiftUI-petSocialApp.git',
    image:
      'https://media.istockphoto.com/id/1845512061/photo/cute-domestic-cats-and-dogs-of-various-colors-run-through-a-summer-sunny-meadow.webp?a=1&b=1&s=612x612&w=0&k=20&c=2J3kbJekOp6Q3MNuSX_94l9mg7RCMxBftwhD-HQdu6I=',
    alt: 'pet social',
  },
  {
    id: '1p',
    title: 'Contact App',
    detail: 'Built with: Swift',
    myLink: 'https://github.com/SukanyaT2022/Swift-ContactApp.git',
    image:
      'https://images.unsplash.com/photo-1615840287214-7ff58936c4cf?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNvbnRhY3R8ZW58MHx8MHx8fDA%3D',
    alt: 'Iphone',
  },
  {
    id: '2p',
    title: 'Photo Search App',
    detail: 'Built with: Swift',
    myLink: 'https://github.com/SukanyaT2022/Pexels-Swift-App.git',
    image:
      'https://images.unsplash.com/photo-1619884889432-b242fdee532a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c2VhcmNofGVufDB8fDB8fHww',
    alt: 'search',
  },
  {
    id: '3p',
    title: 'Expense Tracker APP',
    detail: 'Built with: Swift',
    myLink: 'https://react-js-anti-bully-blog.vercel.app/',
    image:
      'https://images.unsplash.com/photo-1634733988138-bf2c3a2a13fa?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGV4cGVuc2UlMjB0cmFja2VyfGVufDB8fDB8fHww',
    alt: 'calculator',
  },
  {
    id: '4p',
    title: 'Registration Form',
    detail: 'Built with: Swift',
    myLink: 'https://github.com/SukanyaT2022/Swift-RegisterForm.git',
    image:
      'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'register desk',
  },
  {
    id: '5p',
    title: 'E-Commerce Website',
    detail: 'Built with: Swift',
    myLink: 'https://github.com/SukanyaT2022/Swift-eCommerce.git',
    image:
      'https://plus.unsplash.com/premium_photo-1683796112978-fa4b9fa79e58?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8b25saW5lJTIwc2hvcHBpbmd8ZW58MHx8MHx8fDA%3D',
    alt: 'shopping baskets',
  },

];


export const reviews = [
  {
    id: 1,
    name: 'Susan S.',
    job: 'Business Owner',
    image: women,
    text:
      "Working with Tip was a game-changer for our business. They transformed our outdated website into a modern, user-friendly experience. The attention to detail and creativity brought to our project exceeded our expectations. Their technical expertise ensured our site was not only beautiful but also highly functional. We saw a significant increase in user engagement and positive feedback from our customers.",
      alt: 'Spanish woman'
  },
  {
    id: 2,
    name: 'Anna J.',
    job: 'Web Designer',
    image: women4,
    text:
      "Throughout our project, they communicated clearly, met every deadline, and went above and beyond to ensure we were satisfied with the results. Their ability to translate our vision into a sleek, responsive website was impressive. I highly recommend their services to anyone in need of a skilled front-end developer.",
      alt: 'Asian woman'
  },
  {
    id: 3,
    name: 'Peter K.',
    job: 'Entrepreneur',
    image: man3,
    text:
    "We hired this team to work on  our e-commerce platform, and the results were outstanding. They focused on creating a seamless user experience, which significantly boosted our conversion rates. Their understanding of UX/UI principles and ability to implement them effectively is unparalleled. We couldn’t be happier with the new look and functionality of our site.",
    alt: 'American man'
  },
  {
    id: 4,
    name: 'Jennifer A',
    job: 'Business Owner',
    image:
     women6,
    text:
    "Tip brought a perfect blend of creativity and technical excellence to our project. They have a knack for understanding client needs and translating them into beautiful, interactive designs. The performance and aesthetics of our website have greatly improved, attracting more visitors and enhancing user satisfaction. Their passion for front-end development is evident in every detail of their work.",
    alt: 'blond hair woman'
  },
];
export default reviews;

// export default {dataPortfolio,dataReact, dataSwift}


export const dataReactNative = [
  {
    id: '1y',
    title: 'Roam Car Rental App',
    detail: 'Built with: React Native',
    myLink: 'https://github.com/SukanyaT2022/React-Native-Navigation2.git',
    image:
      'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGNhciUyMHJlbnRhbHxlbnwwfHwwfHx8MA%3D%3D',
    alt: 'cars rental',
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.dec17navigation&hl=en-US&ah=ag1OQZKyEte2rYJC4Mu5-YWp2eE&pli=1",
    appleStoreLink: "https://apps.apple.com/in/app/roam-car-rental-pro/id6759920165",
  },

]
